const legacySections = new Set([
  'AnalyticsOverview',
  'AnalyticsOee',
  'AnalyticsWorkCenterEfficiency',
  'AnalyticsPerformance',
  'AnalyticsDowntimeReasons',
  'AnalyticsClassificationResponse',
  'AnalyticsOutput',
  'AnalyticsQuality',
  'AnalyticsEnergy',
  'AnalyticsChecklists',
]);

export function legacyAnalyticsDestination(route) {
  const section = route.hash?.replace(/^#/, '');
  return {
    name: legacySections.has(section) ? section : 'AnalyticsOverview',
    query: route.query,
    hash: '',
  };
}
